import { Button } from '../../../components/button'
import Modal from '../../../components/modal'

export default function HighBid({ onClose, onAccept }) {
  return (
    <Modal onClose={onClose}>
      <div className='wrapper flex flexDirectionColumn alignCenter'>
        <h3>Bidding</h3>
        <p>
          This bid appears to be considerably higher than the current bid, are you sure you would
          like to place it?
        </p>
        <div className='buttonsContainer flex alignCenter justifyCenter'>
          <Button color='secondary' onClick={onClose}>
            No
          </Button>
          <Button autoFocus onClick={onAccept}>
            Yes
          </Button>
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          max-width: 100vw;
          width: 43.6rem;
          padding: 2.8rem 2rem 4.8rem;
          background: #fff;
          border-radius: 1rem;

          h3 {
            font-size: 3.6rem;
          }

          p {
            margin: 2.2rem 0;
            line-height: 2rem;
            text-align: center;
            font-size: 1.6rem;
          }

          .buttonsContainer {
            :global(button) {
              margin: 0 0.35rem;
            }
          }
        }
      `}</style>
    </Modal>
  )
}
